"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-magic-numbers */
const vue_demi_1 = require("vue-demi");
const common_1 = tslib_1.__importDefault(require("../assets/scripts/common"));
const constant_1 = require("../assets/scripts/constant");
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const utils_1 = require("../utils");
const locales_1 = tslib_1.__importDefault(require("./locales"));
const __sfc_main = {};
__sfc_main.props = {
    actSign: {
        key: "actSign",
        required: true,
        type: String
    },
    module: {
        key: "module",
        required: true,
        type: String
    },
    isPreGetPrizeParam: {
        key: "isPreGetPrizeParam",
        required: true,
        type: String
    }
};
__sfc_main.setup = (__props, __ctx) => {
    const { useLang, useToast, useI18n } = require('@fegobull/webapi').use;
    const { lang } = useLang();
    const Toast = useToast();
    const { uid, jumpLogin, updateFegoVariable } = (0, common_1.default)();
    const $tran = useI18n(locales_1.default);
    const props = __props;
    const status = (0, vue_demi_1.reactive)({
        isPreGetPrize: false,
        canClaimPrizeList: [],
        seeBtnLink: '' // 查看按钮链接
    });
    const updatePrizeRuleStatus = () => {
        // 根据 rule_type 第一个值：
        // 1 单门槛取 plan_external_id，
        // 2 多门槛取 plan_external_id:api_rule_sign，并去重
        const rawList = status.canClaimPrizeList.map(item => {
            var _a;
            const { rule_type: ruleTypeArr, plan_external_id: planId, api_rule_sign: apiSign } = (_a = item === null || item === void 0 ? void 0 : item.can_get_prize_judge) !== null && _a !== void 0 ? _a : {};
            const firstRuleType = ruleTypeArr === null || ruleTypeArr === void 0 ? void 0 : ruleTypeArr[0];
            return firstRuleType === 2 ? `${planId}:${apiSign}` : planId;
        });
        const ruleStatusList = [...new Set(rawList)].join(',');
        updateFegoVariable(constant_1.VARIABLE_VALUE_MAP.prizeRuleStatus, ruleStatusList);
    };
    (0, vue_demi_1.watch)(() => status, newStatus => {
        updateFegoVariable(props.isPreGetPrizeParam, newStatus.isPreGetPrize ? '1' : '0');
        updatePrizeRuleStatus();
    }, {
        deep: true,
        immediate: false
    });
    // 做lang的映射
    const langMap = {
        0: 'cn',
        1: 'hk',
        2: 'en',
        5: 'jp'
    };
    function getTitle(title) {
        const titleShow = title[langMap[lang]] || title[langMap[2]];
        return titleShow;
    }
    const isH5Page = (0, vue_demi_1.computed)(() => {
        return (0, utils_1.isH5)();
    });
    /**
     * 请求可领奖奖品列表
     */
    async function requestGetCanClaimPrizeList() {
        try {
            const { list, see_btn_link: seeBtnLink } = await request_1.default.getCanClaimPrizeList({
                config: {
                    actSign: props.actSign,
                    moduleName: props.module
                }
            });
            status.canClaimPrizeList = list; // 可领奖奖品列表
            status.isPreGetPrize = list.find(item => !item.isGet) ? 1 : 0; // 是否有可领奖奖品
            status.seeBtnLink = seeBtnLink;
        }
        catch (error) {
            console.error(error);
        }
    }
    /**
     * 领取单个奖励
     */
    async function requestClaimSinglePrize(prizeId) {
        try {
            Toast.loading(3);
            const { success } = await request_1.default.claimPrize({
                actSign: props.actSign,
                moduleName: props.module,
                apiPrizeSign: prizeId
            });
            if (success) {
                (0, vue_demi_1.nextTick)(() => {
                    requestGetCanClaimPrizeList();
                    Toast.success($tran('claimSinglePrizeSuccess'));
                });
            }
            else {
                Toast.error($tran('claimSinglePrizeFailed'));
            }
        }
        catch (error) {
            console.error(error);
            Toast.error($tran('claimSinglePrizeFailed'));
        }
    }
    /**
     * 一键领取所有奖励
     */
    async function requestClaimAllPrize() {
        try {
            Toast.loading({
                duration: 0
            });
            let successCount = 0;
            const preSendList = status.canClaimPrizeList.filter(item => !item.isGet);
            for (const prize of preSendList) {
                const { success } = await request_1.default.claimPrize({
                    actSign: props.actSign,
                    moduleName: props.module,
                    apiPrizeSign: prize.send_prize_key
                });
                if (success) {
                    // eslint-disable-next-line no-plusplus
                    successCount++;
                }
            }
            Toast.close();
            if (successCount === preSendList.length) {
                Toast.success($tran('claimAllPrizeSuccess'));
            }
            else {
                Toast.error($tran('claimAllPrizeFailed'));
            }
            (0, vue_demi_1.nextTick)(() => {
                requestGetCanClaimPrizeList();
            });
        }
        catch (error) {
            console.error(error);
            Toast.error($tran('claimAllPrizeFailed'));
        }
    }
    function toSeeReward() {
        // 执行到这里
        console.log('====================status.seeBtnLink', status.seeBtnLink);
        window.location.href = status.seeBtnLink;
    }
    (0, vue_demi_1.onMounted)(() => {
        if (uid) {
            requestGetCanClaimPrizeList();
        }
    });
    return Object.assign({
        uid,
        $tran,
        status,
        getTitle,
        isH5Page,
        requestClaimSinglePrize,
        toSeeReward
    }, {
        claimAllPrize: () => {
            if (!uid) {
                return jumpLogin();
            }
            requestClaimAllPrize();
        }
    });
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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